export default __webpack_public_path__ + "static/media/scene1.0c06976d.jpeg";